import AdminDashboardTemplate from '@/components/templates/AdminDashboardTemplate';
import defaultAvatar from '@/assets/images/default-user.png';
import crownIcon from '@/assets/icons/crown.svg';

import React, { useEffect, useState } from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { PAGE } from '@/routes';
import { useDispatch } from 'react-redux';
import { setBreadcrumbs } from '@/store/slices/breadcrumb';
import { useParams } from 'react-router-dom';
import { userService } from '@/services/user.service';
import MobileAppBar from '@/components/molecules/MobileAppBar';
import { useDeviceType } from '@/hooks/useDeviceType';
import ProfileName from '@/components/molecules/ProfileName';
import ProfileInfoCard from '@/components/molecules/ProfileInfoCard';
import SubscriptionPlanCard from '@/components/molecules/SubscriptionPlanCard';

const SubscriberPage = () => {
  const [subscriberProfile, setSubscriberProfile] = useState<any>(null);

  const dispatch = useDispatch();
  const { isMobileView } = useDeviceType();
  const { subscriberId } = useParams();
  console.log('subscriberId', subscriberId);

  const currentUser = {
    photoURL: '',
    username: 'john_doe',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    phoneNumber: '+1234567890'
  };

  const isBasic = true;
  const plan = 'basic';
  //   const amount = '10';

  useEffect(() => {
    // Set breadcrumbs when component mounts
    dispatch(
      setBreadcrumbs([
        {
          title: 'Subscriber',
          path: PAGE.ADMIN_SUBSCRIBERS.path
        },
        {
          title: 'Profile',
          path: ''
        }
      ])
    );
  }, [dispatch]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data: userProfile } = await userService.getUserProfile(subscriberId || '');
        setSubscriberProfile(userProfile);
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    };

    fetchUserProfile();
  }, [subscriberId]);

  return (
    <AdminDashboardTemplate className="flex flex-col !p-0 md:!p-6">
      <MobileAppBar title="PROFILE" variant="primary" showLeftBackButton={true} />
      {isMobileView ? (
        <div className="p-6 space-y-6">
          {/* PROFILE NAME */}
          <ProfileName
            profilePic={subscriberProfile?.profilePicUrl || defaultAvatar}
            name={
              subscriberProfile?.firstName
                ? subscriberProfile.firstName + ' ' + (subscriberProfile?.lastName ?? '')
                : 'Guest User'
            }
          />

          {/* PROFILE INFO */}
          <ProfileInfoCard
            username={subscriberProfile?.username || '-'}
            email={subscriberProfile?.email || '-'}
            phone={subscriberProfile?.phoneNumber || '-'}
            status={subscriberProfile?.status || '-'}
          />

          {/* SUBSCRIPTION INFO */}
          <SubscriptionPlanCard plan="basic" hideChangeButton={true} />
        </div>
      ) : (
        <div className="flex-1 px-6 pt-4 md:pt-5 md:px-5  md:mt-2 bg-[#FBFBFF] md:bg-white md:card">
          <div className="max-w-screen-lg w-full space-y-4">
            <header className="flex items-center justify-between">
              {/* Profile Picture */}
              <div className="flex-1">
                <span className="inline-block text-sm font-medium text-gray mb-3">Profile Picture</span>
                <img
                  className="w-[120px] h-[120px] rounded-full"
                  src={subscriberProfile?.profilePicUrl || defaultAvatar}
                  alt=""
                />
              </div>
              {/* Subscription Plan */}
              <div className="hidden flex-1 md:flex flex-col rounded-[16px] bg-lightPurple border-2 border-primary p-[0.65rem] px-[0.9rem] pb-[0.4rem]">
                <span className="text-xs font-medium mb-[0.35rem]">Subscription Plan</span>
                <span className="font-medium text-base capitalize flex gap-[3px]">
                  {!isBasic && <img src={crownIcon} alt="crown" className="mb-[3px]" />}
                  {plan}
                </span>
                <p className="text-2xl font-bold uppercase leading-[22px] mb-[0.385rem]">
                  FREE
                  {!isBasic && <span className="text-base font-normal capitalize ml-[3px]">/Month</span>}
                </p>
              </div>
            </header>
            <div>
              <span className="text-sm font-medium text-gray">Username</span>
              <p className="text-base font-medium leading-[19.5px]">{subscriberProfile?.username || '-'}</p>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-1">
                <span className="text-sm font-medium text-gray">First name</span>
                <p className="text-base font-medium leading-[19.5px]">{subscriberProfile?.firstName || '-'}</p>
              </div>
              <div className="flex-1">
                <span className="text-sm font-medium text-gray">Last name</span>
                <p className="text-base font-medium leading-[19.5px]">{subscriberProfile?.lastName || '-'}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-1">
                <span className="text-sm font-medium text-gray">Mail</span>
                <p className="text-base font-medium leading-[19.5px]">{subscriberProfile?.email || '-'}</p>
              </div>
              {/* <div className="flex-1">
                <span className="text-sm font-medium text-gray">Phone Number</span>
                <p className="text-base font-medium leading-[19.5px]">
                  {subscriberProfile?.phoneNumber ? formatPhoneNumberIntl(subscriberProfile?.phoneNumber) : '-'}
                </p>
              </div> */}
            </div>
            <div className="flex items-start gap-4">
              <div className="flex-1">
                <span className="text-sm font-medium text-gray">Status</span>
                <p className="text-base font-medium leading-[19.5px] capitalize">{subscriberProfile?.status || '-'}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </AdminDashboardTemplate>
  );
};

export default SubscriberPage;
